import { Component, OnInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthenticationStatus } from '../enums/enums';

@Component({
  selector: 'app-auth-authenticate-method',
  templateUrl: './auth-authenticate-method.component.html',
  styleUrls: ['./auth-authenticate-method.component.css']
})
export class AuthAuthenticateMethodComponent extends AuthBaseComponent implements OnInit {
  public loginOriginAction: string = "";
  public methodValueText = "";

  ngOnInit(): void {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2150' })
      .subscribe(res => console.log("sent elasticLog code:2150 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    sessionStorage.setItem("currentWindow", "בחירת אופן זיהוי אישי");
    sessionStorage.setItem("elasticCode", "2190");
    this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
    this.isShowContactLink = this.shouldContactLink('authMethod');
  }

  submit(form): void {
    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid) {
      this.pending = true;
      this.serverError = null;
      if (form.value == 1)
        this.methodValueText = "ID issue date";
      else this.methodValueText = "credit card";
      //console.log("parametes", form.value);
      this.authUserService.sendAuthData("StrictIdentification", form.value)
        .subscribe((res: AuthenticationResult) => {
          if (res.Status == AuthenticationStatus.Success) {
            this.modalService.close(res.Details);
          }
          else {
            this.serverError = res.Details;
            //console.log("Failure", res.Details);
          }
        }, () => this.pending = false,
          () => this.pending = false
        )
    }
    this.buildFormAccessibility();
  }
}
